import React, { useState } from 'react';
import { Button, Checkbox } from '@economic/taco';
import { Trans } from '@lingui/macro';
import ExternalLink from '~/app/shared/components/ExternalLink';
import welcomeImageSrc from '../../assets/welcome.svg';
import { usePayrollOnboardingContext } from '../../context/OnboardingContext';

// TODO: This is a placeholder URL. Replace it with the actual URL for the terms and conditions.
// Will be done on EC-66511.
const termsAndConditionsUrl = 'https://www.e-conomic.com/terms-and-conditions';

export const WelcomeStep: React.FC = () => {
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const { onNext } = usePayrollOnboardingContext();

    return (
        <div>
            <div className="flex justify-center mb-6">
                <img src={welcomeImageSrc} alt="Welcome" className="w-72" />
            </div>
            <div className="mx-10">
                <h1 className="text-3xl text-center mb-6">
                    <Trans>Welcome to Løn</Trans>
                </h1>
                <p className=" text-center mb-4">
                    <Trans>
                        This is a fully integrated payroll solution of e-conomic. You will be able to pay and control your
                        employees, view and export payslips and integrate payments with your e-conomic accounting.
                    </Trans>
                </p>
                <p className="text-center mb-6">
                    <Trans>Please, complete the following steps.</Trans>
                </p>
                <p className="mb-4">
                    <Trans>
                        Read our{' '}
                        <ExternalLink href={termsAndConditionsUrl} openNewTab>
                            Terms and Conditions
                        </ExternalLink>{' '}
                        to continue.
                    </Trans>
                </p>
                <div className="mb-6 flex items-center">
                    <Checkbox
                        checked={acceptedTerms}
                        onChange={() => {
                            setAcceptedTerms(!acceptedTerms);
                        }}
                        id="terms"
                    />
                    <label htmlFor="terms" className="ml-2">
                        <Trans>I've read the Terms and Conditions to use Løn.</Trans>
                    </label>
                </div>
            </div>
            <div className="flex w-full justify-end">
                <Button onClick={onNext} appearance="primary" disabled={!acceptedTerms}>
                    <Trans>Next</Trans>
                </Button>
            </div>
        </div>
    );
};
